
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PasswordStrength',
  props: {
    password: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'base'
    }
  },
  data() {
    return {
      hasLowerCaseAlphabets: /(?=.*[a-z])/,
      hasUpperCaseAlphabets: /(?=.*[A-Z])/,
      hasNumbers: /(?=.*?[0-9]).{8,}/,
      hasSpecialChars: /(?=.*?[!@#$&*~])/
    }
  },
  computed: {
    sizeClass(): string {
      if (this.size === 'small') return 'h-6 w-6'
      if (this.size === 'base') return 'h-8 w-8'
      if (this.size === 'large') return 'h-10 w-10'

      return 'h-8 w-8'
    },
    passwordScore(): number {
      if (!this.password) {
        return 0
      }

      let currentStrength = 0

      if (this.hasLowerCaseAlphabets.test(this.password)) {
        currentStrength += 0.5
      }

      if (this.hasUpperCaseAlphabets.test(this.password)) {
        currentStrength += 0.5
      }

      if (this.hasNumbers.test(this.password)) {
        currentStrength += 1
      }

      if (this.hasSpecialChars.test(this.password)) {
        currentStrength += 1
      }

      if (this.password.length >= 16) {
        currentStrength += 1
      }

      if (this.password.length >= 24) {
        currentStrength += 0.5
      }

      if (this.password.length >= 32) {
        currentStrength += 0.5
      }

      if (this.password.length >= 40) {
        currentStrength += 0.5
      }

      return currentStrength > 4 ? 4 : Math.ceil(currentStrength)
    },
    passwordGrade(): string {
      switch (true) {
        case this.passwordScore === 4:
          return 'Nice work. This is an excellent secret'
        case this.passwordScore === 3 &&
          this.password.length >= 16 &&
          this.hasNumbers.test(this.password):
          return 'Try adding some special charcters'
        case this.passwordScore === 3 &&
          this.password.length >= 16 &&
          this.hasSpecialChars.test(this.password) &&
          !this.hasNumbers.test(this.password):
          return 'Try adding some numbers'
        case this.passwordScore === 3 && this.password.length <= 16:
          return 'Try a longer secret'
        default:
          return 'This secret is not very secure'
      }
    },
    strokeOffset(): number {
      const circumference = 2 * Math.PI * 15
      const passwordPercent = (this.passwordScore * 100) / 4
      const percentOffset = 100 - passwordPercent
      return (percentOffset * circumference) / 100
    }
  }
})
